let API = {
  information: 'data/yz/user', //个人信息
  indexList: 'data/yz/waitingBonus', // 首页星球中的蓝点
  contributionAnnouncement: 'data/yz/latestContribution', //首页贡献公告
  dividendRanking: 'data/yz/ranking', //分红排⾏（总榜，周榜，成⻓榜）
  withdrawalsRecord: 'data/yz/bonus', //每日分红记录
  contributionRecord: 'data/yz/contribution', //每日分红记录
  bonusInfo: 'data/yz/bonus/info', // 可用分红，累积分红
  contributionInfo: 'data/yz/contribution/info', // 贡献，冻结贡献
  targetTaskIsFinished: 'data/yz/target/isFinished', // 获取指标任务的完成状态
  withdrawList: 'data/yz/cash/list', //提现列表
  withdrawUrl: 'data/yz/withdraw/url', //提现地址
  alipayWithdrawal: 'data/yz/aliPayCash', //支付宝提现
  bankCardWithdrawal: 'data/yz/bankCash', //支付宝提现
  receive: '/bonus/yz/receiveBonus', //领取蓝点接口
  receiveBatch: '/bonus/yz/receiveBonusBatch', //领取蓝点接口
  contributionRanking: 'data/yz/platform', // 平台贡献人数和超过多少人
  taskList: 'data/yz/contributionTask', //贡献任务列表
  signIn: 'market/yz/signIn',
  Color: 'data/yz/global',
  Raiders: 'data/yz/rules',
  realNameData: 'data/yz/realnames',
  homeUrl: 'data/yz/homeUrl',
  textDescription: 'data/yz/introduce', //提现页面和贡献页面文字
  submitRaiderFinished: 'data/yz/viewRaiders',
  verifyMobile: 'yz/verify/mobile',
  trend:'data/yz/trend',
  session:'data/yz/session',
  notice:'data/yz/notice',
  submit: 'contribution/yz/submit',
  aveOrUpdate: '/feedback/saveOrUpdate',
  addCustomInfo: '/user/addCustomInfoCache',
  getCustomInfo: '/user/getCustomInfoCache'
}

export default {
  API: API,
}



// WEBPACK FOOTER //
// ./src/api/index.js